import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, withModifiers as _withModifiers, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-04e4876f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "rooms" }
const _hoisted_2 = { class: "dialog-footer" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Select a location to add to room.", -1))
const _hoisted_4 = { class: "dialog-footer" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mb-4 text-center" }, "This setting is applied by default when new rooms are created.", -1))
const _hoisted_6 = { class: "dialog__roomSettings-content mx-sm-4 py-4 px-sm-4" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "dialog__roomSettings-checkbox-description" }, "Assign alphanumeric codes to new rooms instead of using groupings of common words.", -1))
const _hoisted_8 = { class: "dialog-footer" }
const _hoisted_9 = { class: "d-flex align-items-xl-center justify-content-between flex-xl-row flex-column" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", {
  class: "rooms-heading me-xl-4",
  "data-test": "rooms-list-heading"
}, "All Rooms", -1))
const _hoisted_11 = { class: "order-2 order-xl-1 flex-grow-1 mt-5 mt-xl-0" }
const _hoisted_12 = { class: "order-1 order-xl-2 ms-auto ms-xl-2 d-flex align-items-center" }
const _hoisted_13 = { class: "me-sm-2" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "d-none d-sm-inline-block",
  "data-test": "room-settings-text"
}, "Room Settings", -1))
const _hoisted_15 = { class: "ms-auto order-1 order-sm-2" }
const _hoisted_16 = {
  key: 0,
  class: "onboarding__target onboarding__target--top-left"
}
const _hoisted_17 = {
  key: 0,
  class: "dt-container"
}
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode("When you create "),
  /*#__PURE__*/_createElementVNode("strong", null, "rooms"),
  /*#__PURE__*/_createTextVNode(" they will appear here in your "),
  /*#__PURE__*/_createElementVNode("strong", null, "room inventory"),
  /*#__PURE__*/_createTextVNode(".")
], -1))
const _hoisted_19 = {
  key: 0,
  class: "text-center my-5"
}
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "You haven't added any rooms yet.", -1))
const _hoisted_21 = { class: "inventory-table__actions d-flex flex-column flex-sm-row align-items-sm-end mb-4" }
const _hoisted_22 = { class: "order-3 order-sm-0 mt-4 mt-sm-0" }
const _hoisted_23 = { class: "mx-sm-2" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "small" }, "Filter Rooms By:", -1))
const _hoisted_25 = { class: "me-sm-2 mt-2 mt-sm-0" }
const _hoisted_26 = { class: "me-sm-2 mt-2 mt-sm-0" }
const _hoisted_27 = { class: "ms-sm-auto mt-4 mt-sm-0" }
const _hoisted_28 = { class: "px-1" }
const _hoisted_29 = { class: "d-flex flex-row mb-3" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "expanded-table__heading",
  "data-test": "room-code-table-heading"
}, "Room Code: ", -1))
const _hoisted_31 = ["data-test"]
const _hoisted_32 = { class: "d-flex flex-row mb-3" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "expanded-table__heading",
  "data-test": "room-active-table-heading"
}, "Active: ", -1))
const _hoisted_34 = {
  class: "icon icon--color",
  viewBox: "0 0 24 24"
}
const _hoisted_35 = ["d"]
const _hoisted_36 = { class: "el-tooltip__list" }
const _hoisted_37 = { class: "d-flex flex-row mb-3" }
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "expanded-table__heading",
  "data-test": "room-status-table-heading"
}, "Status: ", -1))
const _hoisted_39 = { key: 0 }
const _hoisted_40 = { key: 0 }
const _hoisted_41 = { key: 1 }
const _hoisted_42 = { key: 2 }
const _hoisted_43 = {
  key: 4,
  class: "receiver-status__popover-link",
  target: "_blank",
  rel: "noreferrer noopener",
  href: "https://help.airsquirrels.com/ditto/413-determining-your-receivers-status"
}
const _hoisted_44 = { key: 0 }
const _hoisted_45 = {
  key: 1,
  class: "icon",
  viewBox: "0 0 24 24"
}
const _hoisted_46 = ["d"]
const _hoisted_47 = { key: 1 }
const _hoisted_48 = { class: "d-flex flex-row mb-3" }
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "expanded-table__heading",
  "data-test": "room-location-heading"
}, "Location: ", -1))
const _hoisted_50 = { class: "d-flex flex-row mb-3" }
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "expanded-table__heading",
  "data-test": "room-sublocation-heading"
}, "Sublocation: ", -1))
const _hoisted_52 = { class: "d-flex flex-row" }
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "expanded-table__heading",
  "data-test": "room-signage-list-heading"
}, "Signage List: ", -1))
const _hoisted_54 = ["onClick"]
const _hoisted_55 = {
  class: "icon--small icon--white",
  viewBox: "0 0 24 24"
}
const _hoisted_56 = ["d"]
const _hoisted_57 = { class: "px-1" }
const _hoisted_58 = { class: "d-flex flex-row mb-3" }
const _hoisted_59 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "expanded-table__heading" }, "Active: ", -1))
const _hoisted_60 = {
  class: "icon icon--color",
  viewBox: "0 0 24 24"
}
const _hoisted_61 = ["d"]
const _hoisted_62 = { class: "el-tooltip__list" }
const _hoisted_63 = { class: "d-flex flex-row mb-3" }
const _hoisted_64 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "expanded-table__heading" }, "Status: ", -1))
const _hoisted_65 = { key: 0 }
const _hoisted_66 = { key: 0 }
const _hoisted_67 = { key: 1 }
const _hoisted_68 = { key: 2 }
const _hoisted_69 = {
  key: 4,
  class: "receiver-status__popover-link",
  target: "_blank",
  rel: "noreferrer noopener",
  href: "https://help.airsquirrels.com/ditto/413-determining-your-receivers-status"
}
const _hoisted_70 = { key: 0 }
const _hoisted_71 = {
  key: 1,
  class: "icon",
  viewBox: "0 0 24 24"
}
const _hoisted_72 = ["d"]
const _hoisted_73 = { key: 1 }
const _hoisted_74 = { class: "d-flex flex-row mb-3" }
const _hoisted_75 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "expanded-table__heading" }, "Location: ", -1))
const _hoisted_76 = { class: "d-flex flex-row mb-3" }
const _hoisted_77 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "expanded-table__heading" }, "Sublocation: ", -1))
const _hoisted_78 = { class: "d-flex flex-row" }
const _hoisted_79 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "expanded-table__heading" }, "Signage List: ", -1))
const _hoisted_80 = ["onClick"]
const _hoisted_81 = {
  class: "icon--small icon--white",
  viewBox: "0 0 24 24"
}
const _hoisted_82 = ["d"]
const _hoisted_83 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "cell",
  "data-test": "room-name-table-heading"
}, "Room Name", -1))
const _hoisted_84 = { class: "d-flex" }
const _hoisted_85 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "cell",
  "data-test": "room-code-table-heading"
}, "Room Code", -1))
const _hoisted_86 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "cell",
  "data-test": "room-active-table-heading"
}, "Active", -1))
const _hoisted_87 = {
  class: "icon icon--color",
  viewBox: "0 0 24 24"
}
const _hoisted_88 = ["d"]
const _hoisted_89 = { class: "el-tooltip__list" }
const _hoisted_90 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "cell",
  "data-test": "room-status-table-heading"
}, "Status", -1))
const _hoisted_91 = { key: 0 }
const _hoisted_92 = { key: 0 }
const _hoisted_93 = { key: 1 }
const _hoisted_94 = { key: 2 }
const _hoisted_95 = {
  key: 4,
  class: "receiver-status__popover-link",
  target: "_blank",
  rel: "noreferrer noopener",
  href: "https://help.airsquirrels.com/ditto/413-determining-your-receivers-status"
}
const _hoisted_96 = { key: 0 }
const _hoisted_97 = {
  key: 1,
  class: "icon",
  viewBox: "0 0 24 24"
}
const _hoisted_98 = ["d"]
const _hoisted_99 = {
  key: 2,
  class: "icon",
  viewBox: "0 0 24 24"
}
const _hoisted_100 = ["d"]
const _hoisted_101 = { key: 1 }
const _hoisted_102 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "cell",
  "data-test": "room-location-table-heading"
}, "Location", -1))
const _hoisted_103 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "cell",
  "data-test": "room-list-sublocation-table-heading"
}, "Sublocation", -1))
const _hoisted_104 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "cell",
  "data-test": "room-signage-list-table-heading"
}, "Signage List", -1))
const _hoisted_105 = {
  class: "icon--small icon--white",
  viewBox: "0 0 24 24"
}
const _hoisted_106 = ["d"]
const _hoisted_107 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_108 = { class: "mx-5" }
const _hoisted_109 = { class: "dialog-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_SubscriptionStatusProgress = _resolveComponent("SubscriptionStatusProgress")!
  const _component_Icon = _resolveComponent("Icon")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_TierLimit = _resolveComponent("TierLimit")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_el_popover = _resolveComponent("el-popover")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _directive_loading = _resolveDirective("loading")!

  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_dialog, {
      title: "Add a Receiver to this Room",
      modelValue: _ctx.receiverPickerVisible,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.receiverPickerVisible) = $event)),
      width: "40%",
      center: "",
      onClose: _ctx.onCancelReceiverPicker
    }, {
      footer: _withCtx(() => [
        _createElementVNode("span", _hoisted_2, [
          _createVNode(_component_el_button, {
            disabled: _ctx.addReceiversApiLoading,
            onClick: _ctx.onCancelReceiverPicker
          }, {
            default: _withCtx(() => [
              _createTextVNode("Cancel")
            ]),
            _: 1
          }, 8, ["disabled", "onClick"]),
          _createVNode(_component_el_button, {
            disabled: _ctx.addReceiversApiLoading,
            type: "primary",
            onClick: _ctx.addReceiversHandler
          }, {
            default: _withCtx(() => [
              _createTextVNode("Confirm")
            ]),
            _: 1
          }, 8, ["disabled", "onClick"])
        ])
      ]),
      default: _withCtx(() => [
        _createElementVNode("span", null, "Select a receiver to add to the room " + _toDisplayString(_ctx.roomBeingAddedTo.roomName) + ".", 1),
        _createVNode(_component_el_select, {
          clearable: "",
          modelValue: _ctx.receiverToLink,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.receiverToLink) = $event)),
          placeholder: _ctx.noReceiversAvailablePlaceholder,
          "value-key": "id",
          disabled: _ctx.noReceiversAvailable
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.availableReceivers, (receiver) => {
              return (_openBlock(), _createBlock(_component_el_option, {
                key: receiver.id,
                label: receiver.displayName,
                value: receiver
              }, null, 8, ["label", "value"]))
            }), 128))
          ]),
          _: 1
        }, 8, ["modelValue", "placeholder", "disabled"])
      ]),
      _: 1
    }, 8, ["modelValue", "onClose"]),
    _createVNode(_component_el_dialog, {
      title: "Assign this Room to a Location",
      modelValue: _ctx.locationPickerVisible,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.locationPickerVisible) = $event)),
      width: "40%",
      center: "",
      onClose: _ctx.onCancelLocationPicker
    }, {
      footer: _withCtx(() => [
        _createElementVNode("span", _hoisted_4, [
          _createVNode(_component_el_button, {
            disabled: _ctx.addReceiversApiLoading,
            onClick: _ctx.onCancelLocationPicker
          }, {
            default: _withCtx(() => [
              _createTextVNode("Cancel")
            ]),
            _: 1
          }, 8, ["disabled", "onClick"]),
          _createVNode(_component_el_button, {
            disabled: _ctx.addLocationsApiLoading,
            type: "primary",
            onClick: _ctx.addLocationHandler
          }, {
            default: _withCtx(() => [
              _createTextVNode("Confirm")
            ]),
            _: 1
          }, 8, ["disabled", "onClick"])
        ])
      ]),
      default: _withCtx(() => [
        _hoisted_3,
        _createVNode(_component_el_select, {
          clearable: "",
          modelValue: _ctx.roomBeingAddedTo.location,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.roomBeingAddedTo.location) = $event)),
          placeholder: _ctx.noLocationsAvailablePlaceholder,
          "value-key": "id",
          disabled: _ctx.noLocationsAvailable
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.locationList, (location) => {
              return (_openBlock(), _createBlock(_component_el_option, {
                value: location,
                label: location.name,
                key: location.id
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(location.name), 1)
                ]),
                _: 2
              }, 1032, ["value", "label"]))
            }), 128))
          ]),
          _: 1
        }, 8, ["modelValue", "placeholder", "disabled"])
      ]),
      _: 1
    }, 8, ["modelValue", "onClose"]),
    _createVNode(_component_el_dialog, {
      title: "Default Room Settings",
      modelValue: _ctx.roomSettingsVisible,
      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.roomSettingsVisible) = $event)),
      onClose: _ctx.roomSettingsCancel,
      width: "30%",
      center: ""
    }, {
      footer: _withCtx(() => [
        _createElementVNode("span", _hoisted_8, [
          _createVNode(_component_el_button, {
            disabled: _ctx.roomSettingsLoading,
            onClick: _ctx.roomSettingsCancel
          }, {
            default: _withCtx(() => [
              _createTextVNode("Cancel")
            ]),
            _: 1
          }, 8, ["disabled", "onClick"]),
          _createVNode(_component_el_button, {
            disabled: _ctx.roomSettingsLoading,
            type: "primary",
            onClick: _ctx.updateOrganization
          }, {
            default: _withCtx(() => [
              _createTextVNode("Save")
            ]),
            _: 1
          }, 8, ["disabled", "onClick"])
        ])
      ]),
      default: _withCtx(() => [
        _hoisted_5,
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_el_checkbox, {
            class: "dialog__roomSettings-checkbox",
            modelValue: _ctx.organization.useSimpleRoomCodes,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.organization.useSimpleRoomCodes) = $event))
          }, {
            default: _withCtx(() => [
              _createTextVNode("Alphanumeric Room Codes")
            ]),
            _: 1
          }, 8, ["modelValue"]),
          _hoisted_7
        ])
      ]),
      _: 1
    }, 8, ["modelValue", "onClose"]),
    _createElementVNode("div", _hoisted_9, [
      _hoisted_10,
      _createElementVNode("div", _hoisted_11, [
        _createVNode(_component_SubscriptionStatusProgress, { class: "subscription-status" })
      ]),
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("div", _hoisted_13, [
          _createVNode(_component_el_tooltip, {
            disabled: _ctx.windowWidth.value >= 576,
            content: "Room Settings",
            "hide-after": 0,
            placement: "bottom"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_button, {
                class: "roomSettings-button py-0",
                type: "text",
                onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.roomSettingsVisible = true)),
                "data-test": "room-settings-button"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_Icon, {
                    class: "me-1",
                    icon: _ctx.mdiCog
                  }, null, 8, ["icon"]),
                  _hoisted_14
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["disabled"])
        ]),
        _createElementVNode("div", _hoisted_15, [
          _createVNode(_component_el_button, {
            onClick: _ctx.onCreate,
            class: _normalizeClass({ 'onboarding__above-overlay' : _ctx.userOnboardStatus.value.isOnboarding && _ctx.userOnboardStatus.value.showDialog && _ctx.currentStep.value.banner }),
            type: "primary",
            "data-test": "add-new-room-button"
          }, {
            default: _withCtx(() => [
              _createTextVNode(" New Room "),
              (_ctx.userOnboardStatus.value.isOnboarding && _ctx.userOnboardStatus.value.showDialog && _ctx.currentStep.value.banner)
                ? (_openBlock(), _createElementBlock("span", _hoisted_16))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["onClick", "class"])
        ])
      ])
    ]),
    (!_ctx.canActivateReceivers)
      ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
          _createVNode(_component_TierLimit, {
            isCallout: true,
            message: _ctx.tierLimitReachedMessage
          }, null, 8, ["message"])
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_el_popover, {
      trigger: "manual",
      placement: "top-start",
      "popper-class": "onboarding__popover",
      width: 300,
      disabled: !_ctx.userOnboardStatus.value.isOnboarding || !_ctx.domLoaded,
      visible: _ctx.userOnboardStatus.value.isOnboarding && _ctx.currentStep.value.banner &&  _ctx.userOnboardStatus.value.showDialog
    }, {
      reference: _withCtx(() => [
        _withDirectives((_openBlock(), _createElementBlock("div", {
          class: _normalizeClass(["dt-container", { 'onboarding__above-overlay onboarding__inventory el-overlay--prevent-clicking' : _ctx.userOnboardStatus.value.isOnboarding && _ctx.currentStep.value.banner &&  _ctx.userOnboardStatus.value.showDialog }])
        }, [
          (_ctx.roomSearchResults.length == 0 && !_ctx.viewLoading && !_ctx.filterEnabled)
            ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                _hoisted_20,
                _createVNode(_component_el_button, {
                  class: _normalizeClass(["px-5 py-3", { 'el-overlay--allow-clicks' : _ctx.userOnboardStatus.value.isOnboarding && _ctx.userOnboardStatus.value.showDialog && _ctx.currentStep.value.banner }]),
                  type: "primary",
                  onClick: _ctx.onCreate
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" Add Your First Room ")
                  ]),
                  _: 1
                }, 8, ["class", "onClick"])
              ]))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _createElementVNode("div", _hoisted_21, [
                  _createElementVNode("div", _hoisted_22, [
                    _createVNode(_component_el_tooltip, {
                      disabled: _ctx.selectedRooms.length > 0,
                      content: "Select rooms to deactivate.",
                      "close-delay": "0",
                      placement: "top"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_button, {
                          class: _normalizeClass(["my-0", { 'is-disabled' : _ctx.selectedRooms.length < 1 }]),
                          onClick: _ctx.deactivateRooms,
                          "data-test": "deactivate-rooms-button"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("Deactivate Rooms")
                          ]),
                          _: 1
                        }, 8, ["class", "onClick"])
                      ]),
                      _: 1
                    }, 8, ["disabled"]),
                    _createVNode(_component_el_tooltip, {
                      disabled: _ctx.selectedRooms.length > 0,
                      content: "Select rooms to delete.",
                      "close-delay": "0",
                      placement: "top"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_button, {
                          class: _normalizeClass(["my-0", { 'is-disabled' : _ctx.selectedRooms.length < 1 }]),
                          onClick: _ctx.massDeleteRooms,
                          "data-test": "delete-rooms-button"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("Delete")
                          ]),
                          _: 1
                        }, 8, ["class", "onClick"])
                      ]),
                      _: 1
                    }, 8, ["disabled"])
                  ]),
                  _createElementVNode("div", _hoisted_23, [
                    _hoisted_24,
                    _createVNode(_component_el_tooltip, {
                      disabled: !_ctx.noLocationsAvailable,
                      content: "No Locations Available"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_select, {
                          clearable: "",
                          modelValue: _ctx.locationFilter,
                          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.locationFilter) = $event)),
                          disabled: _ctx.noLocationsAvailable,
                          placeholder: "Location",
                          onChange: _ctx.handleFilterChange,
                          "data-test": "rooms-location-filter-dropdown"
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.locationList, (location) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                value: location.id,
                                label: location.name,
                                key: location.id,
                                "data-test": `filter-location-selected-${location.name}`
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(location.name), 1)
                                ]),
                                _: 2
                              }, 1032, ["value", "label", "data-test"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue", "disabled", "onChange"])
                      ]),
                      _: 1
                    }, 8, ["disabled"])
                  ]),
                  _createElementVNode("div", _hoisted_25, [
                    _createVNode(_component_el_select, {
                      clearable: "",
                      placeholder: "Active Device",
                      modelValue: _ctx.activeFilter,
                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.activeFilter) = $event)),
                      onChange: _ctx.handleFilterChange,
                      "data-test": "rooms-active-devices-filter-dropdown"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_option, { value: "Yes" }, {
                          default: _withCtx(() => [
                            _createTextVNode("Yes")
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_option, { value: "No" }, {
                          default: _withCtx(() => [
                            _createTextVNode("No")
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["modelValue", "onChange"])
                  ]),
                  _createElementVNode("div", _hoisted_26, [
                    _createVNode(_component_el_select, {
                      clearable: "",
                      placeholder: "Status",
                      modelValue: _ctx.statusFilter,
                      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.statusFilter) = $event)),
                      onChange: _ctx.handleFilterChange,
                      "data-test": "rooms-status-filter-dropdown"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_option, { value: "ONLINE" }, {
                          default: _withCtx(() => [
                            _createTextVNode("ONLINE")
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_option, { value: "OFFLINE" }, {
                          default: _withCtx(() => [
                            _createTextVNode("OFFLINE")
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_option, { value: "WARNING" }, {
                          default: _withCtx(() => [
                            _createTextVNode("WARNING")
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["modelValue", "onChange"])
                  ]),
                  _createElementVNode("div", _hoisted_27, [
                    _createVNode(_component_el_input, {
                      placeholder: "Search Rooms",
                      modelValue: _ctx.roomSearch,
                      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.roomSearch) = $event)),
                      onKeyup: _ctx.handleFilterChange,
                      "data-test": "room-search-input"
                    }, null, 8, ["modelValue", "onKeyup"])
                  ])
                ]),
                (_openBlock(), _createBlock(_component_el_table, {
                  data: _ctx.roomSearchResults,
                  ref: "multipleTable",
                  "row-class-name": _ctx.tableRowClassName,
                  onCellClick: _ctx.handleCurrentChange,
                  onSelectionChange: _ctx.handleSelectionChange,
                  onSortChange: _ctx.sortTable,
                  "default-sort": _ctx.defaultSort,
                  key: _ctx.defaultSortKey,
                  "data-test": "rooms-lists-table"
                }, {
                  default: _withCtx(() => [
                    (_ctx.windowWidth.value < 576)
                      ? (_openBlock(), _createBlock(_component_el_table_column, {
                          key: 0,
                          type: "expand",
                          width: "55"
                        }, {
                          default: _withCtx((props) => [
                            _createElementVNode("div", _hoisted_28, [
                              _createElementVNode("div", _hoisted_29, [
                                _hoisted_30,
                                _createElementVNode("div", {
                                  class: "expanded-table__description",
                                  "data-test": `room-code-${props.row.roomCode}`
                                }, _toDisplayString(props.row.roomCode), 9, _hoisted_31)
                              ]),
                              _createElementVNode("div", _hoisted_32, [
                                _hoisted_33,
                                (props.row.devices && props.row.devices.length)
                                  ? (_openBlock(), _createBlock(_component_el_tooltip, {
                                      key: 0,
                                      placement: "top-start",
                                      title: ""
                                    }, {
                                      content: _withCtx(() => [
                                        _createElementVNode("ul", _hoisted_36, [
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.row.devices, (device, i) => {
                                            return (_openBlock(), _createElementBlock("li", { key: i }, _toDisplayString(device.displayName), 1))
                                          }), 128))
                                        ])
                                      ]),
                                      default: _withCtx(() => [
                                        _createElementVNode("span", null, [
                                          _createTextVNode(" Yes "),
                                          (_openBlock(), _createElementBlock("svg", _hoisted_34, [
                                            _createElementVNode("path", { d: _ctx.mdiCheckBold }, null, 8, _hoisted_35)
                                          ]))
                                        ])
                                      ]),
                                      _: 2
                                    }, 1024))
                                  : (_openBlock(), _createBlock(_component_el_button, {
                                      key: 1,
                                      type: "primary",
                                      plain: "",
                                      round: "",
                                      onClick: _withModifiers(($event: any) => (_ctx.addReceiverTableHandler(props.row)), ["stop"]),
                                      "data-test": "add-receiver-button"
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode("Add Receiver")
                                      ]),
                                      _: 2
                                    }, 1032, ["onClick"]))
                              ]),
                              _createElementVNode("div", _hoisted_37, [
                                _hoisted_38,
                                (props.row.devices && props.row.devices.length > 0 && props.row.status)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                                      _createVNode(_component_el_popover, {
                                        "popper-class": "is-dark",
                                        trigger: "click",
                                        placement: "top-start",
                                        width: 300
                                      }, {
                                        reference: _withCtx(() => [
                                          _createElementVNode("div", {
                                            class: _normalizeClass(`receiver-status__badge receiver-status__badge--${_ctx.roomReceiverStatus(props.row.status).toLowerCase()}`)
                                          }, [
                                            (_ctx.roomReceiverStatus(props.row.status).toLowerCase() != 'legacy')
                                              ? (_openBlock(), _createElementBlock("span", _hoisted_44, _toDisplayString(_ctx.roomReceiverStatus(props.row.status)), 1))
                                              : (_openBlock(), _createElementBlock("svg", _hoisted_45, [
                                                  _createElementVNode("path", { d: _ctx.mdiHelp }, null, 8, _hoisted_46)
                                                ]))
                                          ], 2)
                                        ]),
                                        default: _withCtx(() => [
                                          _createElementVNode("p", null, [
                                            ((_ctx.roomReceiverStatus(props.row.status).toLowerCase() === 'online') || (_ctx.roomReceiverStatus(props.row.status).toLowerCase() === 'offline'))
                                              ? (_openBlock(), _createElementBlock("span", _hoisted_40, " The status for all receivers is " + _toDisplayString(_ctx.roomReceiverStatus(props.row.status).toLowerCase()) + ". ", 1))
                                              : (_ctx.roomReceiverStatus(props.row.status).toLowerCase() === 'legacy')
                                                ? (_openBlock(), _createElementBlock("span", _hoisted_41, " Legacy receivers do not support receiver status. "))
                                                : (_openBlock(), _createElementBlock("span", _hoisted_42, "The status for 1 or more receivers is not online. ")),
                                            (_ctx.roomReceiverStatus(props.row.status).toLowerCase() != 'legacy')
                                              ? (_openBlock(), _createBlock(_component_router_link, {
                                                  key: 3,
                                                  class: "receiver-status__popover-link",
                                                  target: "_blank",
                                                  rel: "noreferrer noopener",
                                                  to: `/rooms/${props.row.id}#receiver`
                                                }, {
                                                  default: _withCtx(() => [
                                                    _createTextVNode(" Click here to view all receivers. ")
                                                  ]),
                                                  _: 2
                                                }, 1032, ["to"]))
                                              : (_openBlock(), _createElementBlock("a", _hoisted_43, " Click here to learn more. "))
                                          ])
                                        ]),
                                        _: 2
                                      }, 1024)
                                    ]))
                                  : (_openBlock(), _createElementBlock("div", _hoisted_47, "-"))
                              ]),
                              _createElementVNode("div", _hoisted_48, [
                                _hoisted_49,
                                (props.row.location && props.row.location.parentId)
                                  ? (_openBlock(), _createBlock(_component_router_link, {
                                      key: 0,
                                      class: "expanded-table__description",
                                      to: `/locations/${props.row.location.parentId}`
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(props.row.location.parentName), 1)
                                      ]),
                                      _: 2
                                    }, 1032, ["to"]))
                                  : (props.row.location && props.row.location.id)
                                    ? (_openBlock(), _createBlock(_component_router_link, {
                                        key: 1,
                                        class: "expanded-table__description",
                                        to: `/locations/${props.row.location.id}`,
                                        "data-test": `room-location-${props.row.location.id}`
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(props.row.location.name), 1)
                                        ]),
                                        _: 2
                                      }, 1032, ["to", "data-test"]))
                                    : (_openBlock(), _createBlock(_component_el_button, {
                                        key: 2,
                                        type: "primary",
                                        plain: "",
                                        round: "",
                                        onClick: _withModifiers(($event: any) => (_ctx.addLocationsTableHandler(props.row)), ["stop"]),
                                        id: props.row.id,
                                        "data-test": "room-add-location-button"
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode("Add Location")
                                        ]),
                                        _: 2
                                      }, 1032, ["onClick", "id"]))
                              ]),
                              _createElementVNode("div", _hoisted_50, [
                                _hoisted_51,
                                (props.row.location && props.row.location.parentId && props.row.location.id)
                                  ? (_openBlock(), _createBlock(_component_router_link, {
                                      key: 0,
                                      class: "expanded-table__description",
                                      to: `/locations/${props.row.location.id}`,
                                      "data-test": `room-sublocation-${props.row.location.id}`
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(props.row.location.name), 1)
                                      ]),
                                      _: 2
                                    }, 1032, ["to", "data-test"]))
                                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                      _createTextVNode("-")
                                    ], 64))
                              ]),
                              _createElementVNode("div", _hoisted_52, [
                                _hoisted_53,
                                _createElementVNode("a", {
                                  class: "expanded-table__description",
                                  onClick: _withModifiers(($event: any) => (_ctx.onSignageListClick(props.row)), ["stop"])
                                }, _toDisplayString(props.row.signageListCount), 9, _hoisted_54)
                              ]),
                              _createVNode(_component_el_button, {
                                class: "mt-4 mb-3 el-table-row__delete-button el-table-row__delete-button--mobile",
                                type: "danger",
                                id: props.row.id,
                                onClick: ($event: any) => (_ctx.deleteRoom(props.row.id)),
                                circle: "",
                                "data-test": `room-${props.row.id}-delete-button`
                              }, {
                                default: _withCtx(() => [
                                  (_openBlock(), _createElementBlock("svg", _hoisted_55, [
                                    _createElementVNode("path", { d: _ctx.mdiDelete }, null, 8, _hoisted_56)
                                  ]))
                                ]),
                                _: 2
                              }, 1032, ["id", "onClick", "data-test"])
                            ])
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    (_ctx.windowWidth.value >= 576 && _ctx.windowWidth.value < 992)
                      ? (_openBlock(), _createBlock(_component_el_table_column, {
                          key: 1,
                          type: "expand",
                          width: "55"
                        }, {
                          default: _withCtx((props) => [
                            _createElementVNode("div", _hoisted_57, [
                              _createElementVNode("div", _hoisted_58, [
                                _hoisted_59,
                                (props.row.devices && props.row.devices.length)
                                  ? (_openBlock(), _createBlock(_component_el_tooltip, {
                                      key: 0,
                                      placement: "top-start",
                                      title: ""
                                    }, {
                                      content: _withCtx(() => [
                                        _createElementVNode("ul", _hoisted_62, [
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.row.devices, (device, i) => {
                                            return (_openBlock(), _createElementBlock("li", { key: i }, _toDisplayString(device.displayName), 1))
                                          }), 128))
                                        ])
                                      ]),
                                      default: _withCtx(() => [
                                        _createElementVNode("span", null, [
                                          _createTextVNode(" Yes "),
                                          (_openBlock(), _createElementBlock("svg", _hoisted_60, [
                                            _createElementVNode("path", { d: _ctx.mdiCheckBold }, null, 8, _hoisted_61)
                                          ]))
                                        ])
                                      ]),
                                      _: 2
                                    }, 1024))
                                  : (_openBlock(), _createBlock(_component_el_button, {
                                      key: 1,
                                      type: "primary",
                                      plain: "",
                                      round: "",
                                      onClick: _withModifiers(($event: any) => (_ctx.addReceiverTableHandler(props.row)), ["stop"])
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode("Add Receiver")
                                      ]),
                                      _: 2
                                    }, 1032, ["onClick"]))
                              ]),
                              _createElementVNode("div", _hoisted_63, [
                                _hoisted_64,
                                (props.row.devices && props.row.devices.length > 0 && props.row.status)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_65, [
                                      _createVNode(_component_el_popover, {
                                        "popper-class": "is-dark",
                                        trigger: "click",
                                        placement: "top-start",
                                        width: 300
                                      }, {
                                        reference: _withCtx(() => [
                                          _createElementVNode("div", {
                                            class: _normalizeClass(`receiver-status__badge receiver-status__badge--${_ctx.roomReceiverStatus(props.row.status).toLowerCase()}`)
                                          }, [
                                            (_ctx.roomReceiverStatus(props.row.status).toLowerCase() != 'legacy')
                                              ? (_openBlock(), _createElementBlock("span", _hoisted_70, _toDisplayString(_ctx.roomReceiverStatus(props.row.status)), 1))
                                              : (_openBlock(), _createElementBlock("svg", _hoisted_71, [
                                                  _createElementVNode("path", { d: _ctx.mdiHelp }, null, 8, _hoisted_72)
                                                ]))
                                          ], 2)
                                        ]),
                                        default: _withCtx(() => [
                                          _createElementVNode("p", null, [
                                            ((_ctx.roomReceiverStatus(props.row.status).toLowerCase() === 'online') || (_ctx.roomReceiverStatus(props.row.status).toLowerCase() === 'offline'))
                                              ? (_openBlock(), _createElementBlock("span", _hoisted_66, " The status for all receivers is " + _toDisplayString(_ctx.roomReceiverStatus(props.row.status).toLowerCase()) + ". ", 1))
                                              : (_ctx.roomReceiverStatus(props.row.status).toLowerCase() === 'legacy')
                                                ? (_openBlock(), _createElementBlock("span", _hoisted_67, " Legacy receivers do not support receiver status. "))
                                                : (_openBlock(), _createElementBlock("span", _hoisted_68, "The status for 1 or more receivers is not online. ")),
                                            (_ctx.roomReceiverStatus(props.row.status).toLowerCase() != 'legacy')
                                              ? (_openBlock(), _createBlock(_component_router_link, {
                                                  key: 3,
                                                  class: "receiver-status__popover-link",
                                                  to: `/rooms/${props.row.id}#receiver`
                                                }, {
                                                  default: _withCtx(() => [
                                                    _createTextVNode(" Click here to view all receivers. ")
                                                  ]),
                                                  _: 2
                                                }, 1032, ["to"]))
                                              : (_openBlock(), _createElementBlock("a", _hoisted_69, " Click here to learn more. "))
                                          ])
                                        ]),
                                        _: 2
                                      }, 1024)
                                    ]))
                                  : (_openBlock(), _createElementBlock("div", _hoisted_73, "-"))
                              ]),
                              _createElementVNode("div", _hoisted_74, [
                                _hoisted_75,
                                (props.row.location && props.row.location.parentId)
                                  ? (_openBlock(), _createBlock(_component_router_link, {
                                      key: 0,
                                      class: "expanded-table__description",
                                      to: `/locations/${props.row.location.parentId}`
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(props.row.location.parentName), 1)
                                      ]),
                                      _: 2
                                    }, 1032, ["to"]))
                                  : (props.row.location && props.row.location.id)
                                    ? (_openBlock(), _createBlock(_component_router_link, {
                                        key: 1,
                                        class: "expanded-table__description",
                                        to: `/locations/${props.row.location.id}`
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(props.row.location.name), 1)
                                        ]),
                                        _: 2
                                      }, 1032, ["to"]))
                                    : (_openBlock(), _createBlock(_component_el_button, {
                                        key: 2,
                                        type: "primary",
                                        plain: "",
                                        round: "",
                                        onClick: _withModifiers(($event: any) => (_ctx.addLocationsTableHandler(props.row)), ["stop"]),
                                        id: props.row.id
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode("Add Location")
                                        ]),
                                        _: 2
                                      }, 1032, ["onClick", "id"]))
                              ]),
                              _createElementVNode("div", _hoisted_76, [
                                _hoisted_77,
                                (props.row.location && props.row.location.parentId && props.row.location.id)
                                  ? (_openBlock(), _createBlock(_component_router_link, {
                                      key: 0,
                                      class: "expanded-table__description",
                                      to: `/locations/${props.row.location.id}`
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(props.row.location.name), 1)
                                      ]),
                                      _: 2
                                    }, 1032, ["to"]))
                                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                      _createTextVNode("-")
                                    ], 64))
                              ]),
                              _createElementVNode("div", _hoisted_78, [
                                _hoisted_79,
                                _createElementVNode("a", {
                                  class: "expanded-table__description",
                                  onClick: _withModifiers(($event: any) => (_ctx.onSignageListClick(props.row)), ["stop"])
                                }, _toDisplayString(props.row.signageListCount), 9, _hoisted_80)
                              ]),
                              _createVNode(_component_el_button, {
                                class: "mt-4 mb-3 el-table-row__delete-button el-table-row__delete-button--mobile",
                                type: "danger",
                                id: props.row.id,
                                onClick: ($event: any) => (_ctx.deleteRoom(props.row.id)),
                                circle: ""
                              }, {
                                default: _withCtx(() => [
                                  (_openBlock(), _createElementBlock("svg", _hoisted_81, [
                                    _createElementVNode("path", { d: _ctx.mdiDelete }, null, 8, _hoisted_82)
                                  ]))
                                ]),
                                _: 2
                              }, 1032, ["id", "onClick"])
                            ])
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    _createVNode(_component_el_table_column, {
                      type: "selection",
                      width: "55",
                      onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.selectionColumnClickHandler($event)))
                    }),
                    _createVNode(_component_el_table_column, {
                      prop: "roomName",
                      label: "Room Name",
                      sortable: "custom"
                    }, {
                      header: _withCtx(() => [
                        _hoisted_83
                      ]),
                      default: _withCtx((scope) => [
                        _createElementVNode("div", _hoisted_84, [
                          _createVNode(_component_router_link, {
                            class: "el-table-column__name me-1 me-sm-0",
                            to: `/rooms/${scope.row.id}`
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(scope.row.roomName), 1)
                            ]),
                            _: 2
                          }, 1032, ["to"]),
                          (_ctx.windowWidth.value < 576 && scope.row.devices && scope.row.devices.length > 0 && scope.row.status)
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 0,
                                class: _normalizeClass(`ms-auto align-self-center receiver-status__badge__mobile receiver-status__badge__mobile--${_ctx.roomReceiverStatus(scope.row.status).toLowerCase()}`),
                                "aria-hidden": "true"
                              }, null, 2))
                            : _createCommentVNode("", true)
                        ])
                      ]),
                      _: 1
                    }),
                    (_ctx.windowWidth.value >= 576)
                      ? (_openBlock(), _createBlock(_component_el_table_column, {
                          key: 2,
                          prop: "roomCode",
                          label: "Room Code",
                          sortable: "custom"
                        }, {
                          header: _withCtx(() => [
                            _hoisted_85
                          ]),
                          default: _withCtx((scope) => [
                            _createElementVNode("span", null, _toDisplayString(scope.row.roomCode), 1)
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    (_ctx.windowWidth.value >= 992)
                      ? (_openBlock(), _createBlock(_component_el_table_column, {
                          key: 3,
                          prop: "devices",
                          label: "Active",
                          sortable: "custom"
                        }, {
                          header: _withCtx(() => [
                            _hoisted_86
                          ]),
                          default: _withCtx((scope) => [
                            (scope.row.devices && scope.row.devices.length)
                              ? (_openBlock(), _createBlock(_component_el_tooltip, {
                                  key: 0,
                                  placement: "top-start",
                                  title: "",
                                  width: 200
                                }, {
                                  content: _withCtx(() => [
                                    _createElementVNode("ul", _hoisted_89, [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(scope.row.devices, (device, i) => {
                                        return (_openBlock(), _createElementBlock("li", { key: i }, _toDisplayString(device.displayName), 1))
                                      }), 128))
                                    ])
                                  ]),
                                  default: _withCtx(() => [
                                    _createElementVNode("span", null, [
                                      _createTextVNode(" Yes "),
                                      (_openBlock(), _createElementBlock("svg", _hoisted_87, [
                                        _createElementVNode("path", { d: _ctx.mdiCheckBold }, null, 8, _hoisted_88)
                                      ]))
                                    ])
                                  ]),
                                  _: 2
                                }, 1024))
                              : (_openBlock(), _createBlock(_component_el_button, {
                                  key: 1,
                                  type: "primary",
                                  plain: "",
                                  round: "",
                                  onClick: _withModifiers(($event: any) => (_ctx.addReceiverTableHandler(scope.row)), ["stop"]),
                                  "data-test": "room-add-receiver-button"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode("Add Receiver")
                                  ]),
                                  _: 2
                                }, 1032, ["onClick"]))
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    (_ctx.windowWidth.value >= 992)
                      ? (_openBlock(), _createBlock(_component_el_table_column, {
                          key: 4,
                          prop: "status",
                          label: "Status",
                          sortable: "custom"
                        }, {
                          header: _withCtx(() => [
                            _hoisted_90
                          ]),
                          default: _withCtx((scope) => [
                            (scope.row.devices && scope.row.devices.length > 0 && scope.row.status)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_91, [
                                  _createVNode(_component_el_popover, {
                                    "popper-class": "is-dark",
                                    trigger: "hover",
                                    placement: "top-start",
                                    width: 300
                                  }, {
                                    reference: _withCtx(() => [
                                      _createElementVNode("div", {
                                        class: _normalizeClass(`receiver-status__badge receiver-status__badge--${_ctx.roomReceiverStatus(scope.row.status).toLowerCase()}`)
                                      }, [
                                        (_ctx.roomReceiverStatus(scope.row.status).toLowerCase() != 'legacy' && _ctx.roomReceiverStatus(scope.row.status).toLowerCase() != 'warning' && (_ctx.roomReceiverStatus(scope.row.status).toLowerCase() == 'offline' || _ctx.roomReceiverStatus(scope.row.status).toLowerCase() == 'online'))
                                          ? (_openBlock(), _createElementBlock("span", _hoisted_96, _toDisplayString(_ctx.roomReceiverStatus(scope.row.status)), 1))
                                          : (_ctx.roomReceiverStatus(scope.row.status).toLowerCase() == 'warning')
                                            ? (_openBlock(), _createElementBlock("svg", _hoisted_97, [
                                                _createElementVNode("path", { d: _ctx.mdiExclamationThick }, null, 8, _hoisted_98)
                                              ]))
                                            : (_openBlock(), _createElementBlock("svg", _hoisted_99, [
                                                _createElementVNode("path", { d: _ctx.mdiHelp }, null, 8, _hoisted_100)
                                              ]))
                                      ], 2)
                                    ]),
                                    default: _withCtx(() => [
                                      _createElementVNode("p", null, [
                                        ((_ctx.roomReceiverStatus(scope.row.status).toLowerCase() === 'online') || (_ctx.roomReceiverStatus(scope.row.status).toLowerCase() === 'offline'))
                                          ? (_openBlock(), _createElementBlock("span", _hoisted_92, " The status for all receivers is " + _toDisplayString(_ctx.roomReceiverStatus(scope.row.status).toLowerCase()) + ". ", 1))
                                          : (_ctx.roomReceiverStatus(scope.row.status).toLowerCase() === 'legacy')
                                            ? (_openBlock(), _createElementBlock("span", _hoisted_93, " Legacy receivers do not support receiver status. "))
                                            : (_openBlock(), _createElementBlock("span", _hoisted_94, "The status for 1 or more receivers is not online. ")),
                                        (_ctx.roomReceiverStatus(scope.row.status).toLowerCase() != 'legacy')
                                          ? (_openBlock(), _createBlock(_component_router_link, {
                                              key: 3,
                                              class: "receiver-status__popover-link",
                                              target: "_blank",
                                              rel: "noreferrer noopener",
                                              to: `/rooms/${scope.row.id}#receiver`
                                            }, {
                                              default: _withCtx(() => [
                                                _createTextVNode(" Click here to view all receivers. ")
                                              ]),
                                              _: 2
                                            }, 1032, ["to"]))
                                          : (_openBlock(), _createElementBlock("a", _hoisted_95, " Click here to learn more. "))
                                      ])
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]))
                              : (_openBlock(), _createElementBlock("div", _hoisted_101, "-"))
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    (_ctx.windowWidth.value >= 992)
                      ? (_openBlock(), _createBlock(_component_el_table_column, {
                          key: 5,
                          prop: "lowercaseLocation, id",
                          label: "Location",
                          sortable: "custom"
                        }, {
                          header: _withCtx(() => [
                            _hoisted_102
                          ]),
                          default: _withCtx((scope) => [
                            (scope.row.location.id && scope.row.location.parentId)
                              ? (_openBlock(), _createBlock(_component_router_link, {
                                  key: 0,
                                  to: `/locations/${scope.row.location.parentId}`
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(scope.row.location.parentName), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["to"]))
                              : (scope.row.location.id)
                                ? (_openBlock(), _createBlock(_component_router_link, {
                                    key: 1,
                                    to: `/locations/${scope.row.location.id}`
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(scope.row.location.name), 1)
                                    ]),
                                    _: 2
                                  }, 1032, ["to"]))
                                : (_openBlock(), _createBlock(_component_el_button, {
                                    key: 2,
                                    type: "primary",
                                    plain: "",
                                    round: "",
                                    onClick: _withModifiers(($event: any) => (_ctx.addLocationsTableHandler(scope.row)), ["stop"]),
                                    id: scope.row.id,
                                    "data-test": "room-add-location-button"
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode("Add Location")
                                    ]),
                                    _: 2
                                  }, 1032, ["onClick", "id"]))
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    (_ctx.windowWidth.value >= 992)
                      ? (_openBlock(), _createBlock(_component_el_table_column, {
                          key: 6,
                          prop: "subLocation, id",
                          label: "Sublocation",
                          sortable: "custom"
                        }, {
                          header: _withCtx(() => [
                            _hoisted_103
                          ]),
                          default: _withCtx((scope) => [
                            (scope.row.location && scope.row.location.parentId)
                              ? (_openBlock(), _createBlock(_component_router_link, {
                                  key: 0,
                                  to: `/locations/${scope.row.location.id}`
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(scope.row.location.name), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["to"]))
                              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                  _createTextVNode("-")
                                ], 64))
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    (_ctx.windowWidth.value >= 992)
                      ? (_openBlock(), _createBlock(_component_el_table_column, {
                          key: 7,
                          prop: "signageListCount",
                          label: "Signage List",
                          align: "center",
                          sortable: "custom"
                        }, {
                          header: _withCtx(() => [
                            _hoisted_104
                          ]),
                          default: _withCtx((scope) => [
                            _createVNode(_component_el_button, {
                              type: "text",
                              onClick: _withModifiers(($event: any) => (_ctx.onSignageListClick(scope.row)), ["stop"]),
                              "data-test": "room-signage-list-button"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(scope.row.signageListCount), 1)
                              ]),
                              _: 2
                            }, 1032, ["onClick"])
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    (_ctx.windowWidth.value >= 992)
                      ? (_openBlock(), _createBlock(_component_el_table_column, {
                          key: 8,
                          prop: "id",
                          "class-name": "el-table-row__delete",
                          width: "50"
                        }, {
                          default: _withCtx((scope) => [
                            _createVNode(_component_el_button, {
                              class: "el-table-row__delete-button",
                              type: "danger",
                              id: scope.row.id,
                              onClick: ($event: any) => (_ctx.deleteRoom(scope.row.id)),
                              circle: "",
                              "data-test": "room-details-delete-button"
                            }, {
                              default: _withCtx(() => [
                                (_openBlock(), _createElementBlock("svg", _hoisted_105, [
                                  _createElementVNode("path", { d: _ctx.mdiDelete }, null, 8, _hoisted_106)
                                ]))
                              ]),
                              _: 2
                            }, 1032, ["id", "onClick"])
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }, 8, ["data", "row-class-name", "onCellClick", "onSelectionChange", "onSortChange", "default-sort"])),
                _hoisted_107,
                _createVNode(_component_el_pagination, {
                  class: "d-flex justify-content-center",
                  background: "",
                  layout: "prev, pager, next, slot",
                  total: _ctx.roomCount,
                  "page-size": _ctx.paging.pageSize,
                  onCurrentChange: _ctx.handleCurrentPageChange,
                  onSizeChange: _ctx.handleSizeChange,
                  "current-page": _ctx.paging.pageIndex,
                  "onUpdate:currentPage": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.paging.pageIndex) = $event))
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", null, [
                      _createVNode(_component_el_select, {
                        onChange: _ctx.handleSizeChange,
                        "model-value": _ctx.paging.pageSize,
                        size: "small"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_option, {
                            label: "10 per page",
                            value: 10
                          }),
                          _createVNode(_component_el_option, {
                            label: "50 per page",
                            value: 50
                          }),
                          _createVNode(_component_el_option, {
                            label: "100 per page",
                            value: 100
                          }),
                          _createVNode(_component_el_option, {
                            label: "500 per page",
                            value: 500
                          }),
                          _createVNode(_component_el_option, {
                            label: "All",
                            value: 100000
                          })
                        ]),
                        _: 1
                      }, 8, ["onChange", "model-value"])
                    ])
                  ]),
                  _: 1
                }, 8, ["total", "page-size", "onCurrentChange", "onSizeChange", "current-page"])
              ], 64))
        ], 2)), [
          [_directive_loading, _ctx.viewLoading]
        ])
      ]),
      default: _withCtx(() => [
        _hoisted_18
      ]),
      _: 1
    }, 8, ["disabled", "visible"]),
    _createVNode(_component_el_dialog, {
      title: _ctx.signageListModalTitle,
      "custom-class": "signage__creation-dialog",
      modelValue: _ctx.isSignageListModalVisible,
      "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.isSignageListModalVisible) = $event))
    }, {
      footer: _withCtx(() => [
        _createElementVNode("span", _hoisted_109, [
          _createVNode(_component_el_button, {
            onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.isSignageListModalVisible = false))
          }, {
            default: _withCtx(() => [
              _createTextVNode("Close")
            ]),
            _: 1
          })
        ])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_108, [
          _createVNode(_component_el_table, {
            data: _ctx.selectedRoomLists,
            "show-header": false,
            "max-height": "250",
            "empty-text": "No signage lists"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_table_column, null, {
                default: _withCtx((scope) => [
                  _createVNode(_component_router_link, {
                    to: `/signage/${scope.row.id}`,
                    "data-test": "room-signage-list-link"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(scope.row.name), 1)
                    ]),
                    _: 2
                  }, 1032, ["to"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["data"])
        ])
      ]),
      _: 1
    }, 8, ["title", "modelValue"]),
    _createVNode(_component_TierLimit, {
      modelValue: _ctx.showTierDialog,
      "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.showTierDialog) = $event)),
      isCallout: false,
      isLimit: true,
      message: _ctx.tierLimitReachedMessage,
      onModalClosed: _cache[16] || (_cache[16] = ($event: any) => (_ctx.showTierDialog = false))
    }, null, 8, ["modelValue", "message"])
  ])), [
    [_directive_loading, _ctx.viewLoading]
  ])
}